import { Head, router, useForm } from "@inertiajs/react"

import { ProductForm } from "@/components/products/product-form"
import AppLayout from "@/layouts/app-layout"
import { productPath } from "@/routes"

interface Product {
  id: number
  name: string
  description?: string
  price: number
  sale_price?: number
  currency: string
  in_stock: boolean
  stock_quantity?: number
  unit?: string
  category?: { id: number; name: string }
  status: "active" | "inactive" | "out_of_stock"
  condition?: "new" | "like_new" | "good" | "fair"
}

interface ProductsEditProps {
  product: Product
  categories: { id: number; name: string }[]
  errors?: Record<string, string>
  existing_images?: { id: number | string; url: string }[]
}

export default function ProductsEdit({
  product,
  categories,
  errors = {},
  existing_images = [],
}: ProductsEditProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, setData, put, processing } = useForm<{ product: any }>({
    product: {
      name: product.name ?? "",
      description: product.description ?? "",
      price: String(product.price ?? ""),
      sale_price: product.sale_price != null ? String(product.sale_price) : "",
      currency: product.currency ?? "EUR",
      in_stock: !!product.in_stock,
      stock_quantity:
        product.stock_quantity != null ? String(product.stock_quantity) : "",
      unit: product.unit ?? "",
      category_id: product.category?.id ? String(product.category.id) : "",
      status: product.status ?? "active",
      condition: product.condition ?? "new",
      tags: "",
      images: [],
      image_urls: [],
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    put(productPath(product.id), { forceFormData: true })
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title={`Editar producto - ${product.name}`} />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <ProductForm
          title="Editar producto"
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          data={data.product}
          errors={err}
          categories={categories}
          existingImages={existing_images}
          processing={processing}
          onChange={(partial) =>
            setData("product", { ...data.product, ...partial })
          }
          onSubmit={submit}
          onCancel={() => router.visit(productPath(product.id))}
          submitLabel="Actualizar"
        />
      </div>
    </AppLayout>
  )
}
